// frontend/src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AuthProvider from "./contexts/AuthContext";
import SurveyProvider from "./contexts/SurveyContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { NotificationProvider } from "./contexts/NotificationContext";
import AuthWrapper from "./AuthWrapper";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error(
    "Failed to find the root element. Please ensure there is a <div id='root'></div> in your HTML."
  );
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <SurveyProvider>
          <NotificationProvider>
            {/* Use AuthWrapper, which conditionally includes SocketProvider */}
            <AuthWrapper />
            <ToastContainer />
          </NotificationProvider>
        </SurveyProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
